module.exports = __webpack_public_path__ + "img/blockables-instructions-1.8825ab7e.png";